import { apiFetch } from "./client";

const createPrintJob = async (payload) =>
  apiFetch("/api/print-jobs", {
    method: "POST",
    body: JSON.stringify(payload),
  });

const fetchPrintJob = async (jobId, token) =>
  apiFetch(`/api/print-jobs/${jobId}?token=${encodeURIComponent(token || "")}`);

export { createPrintJob, fetchPrintJob };
